export default __webpack_public_path__ + "static/media/What we did when we started_2.00c9746a.png";